module.exports = __webpack_public_path__ + "img/sfq6.43818cb8.png";